import type { BioclastParams } from "./bioclast";
import type { AltSceneType } from "../altScenes";
import { SCENES, resolveSceneValues, type ScenePreset } from "./scenePresets";

type SceneType = "bioclast" | AltSceneType;

export type ResolvedSceneLink = {
  scene: ScenePreset;
  sceneType: SceneType;
  values: Partial<BioclastParams>;
};

function normalizeSceneToken(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, "");
}

export function resolveSceneLink(token: string | null): ResolvedSceneLink | null {
  if (!token) return null;
  const normalized = normalizeSceneToken(token);
  const scene = SCENES.find((candidate) => {
    const nameMatches = normalizeSceneToken(candidate.name) === normalized;
    const typeMatches = candidate.sceneType ? normalizeSceneToken(candidate.sceneType) === normalized : false;
    return nameMatches || typeMatches;
  });
  if (!scene) return null;
  return {
    scene,
    sceneType: scene.sceneType ?? "bioclast",
    values: resolveSceneValues(scene, null),
  };
}